import React from "react"
import styled from "styled-components"
import { Flex, Icon, Text } from ".."
import { breakpoints, colors, scale } from "../../styles"

export interface NavigationPopupStyledProps {
	size: "small" | "normal"
	isSearchPopup: boolean
	arrowOffset: string
	children?: React.ReactNode
}
export interface NavigationPopupProps extends NavigationPopupStyledProps {
	heading: string
	showPopup: React.Dispatch<React.SetStateAction<boolean>>
}

const ButtonStyled = styled.button`
	&:hover {
		svg,
		path {
			fill: ${colors.hoverBlue};
		}
	}
`

const NavigationPopupStyled = styled.div<NavigationPopupStyledProps>`
	display: flex;
	position: absolute;
	flex-direction: column;
	padding: ${scale.px(4)};
	min-width: ${scale.px(45)};
	max-width: ${(props) => (props.isSearchPopup ? scale.px(69) : scale.px(46))};
	background-color: ${colors.white};
	border-radius: 24px;
	box-shadow: 0px 0px 50px #33333363;
	top: 74px;
	right: ${(props) => (props.isSearchPopup ? '-20px' : 0)};
	width: 100vw;
	z-index: 15;

	&::before {
		content: "";
		position: absolute;
		top: -24px;
		right: ${(props) => (`${props.arrowOffset}`)};
		width: 48px;
		height: 28px;
		clip-path: polygon(50% 0, 100% 100%, 0% 100%);
		background-color: ${colors.white};
	}

	@media screen and (max-width: ${breakpoints.l}px) {
		position: relative;
		min-width: 0;
		top: 10px;
		right: 0px;
		&::before {
			right: ${(props) => (props.isSearchPopup ? "156px" : "53px")};
			top: -24px;
		}
	}
`

const NavigationPopup: React.FC<NavigationPopupProps> = ({
	heading,
	showPopup,
	size,
	isSearchPopup,
	arrowOffset,
	children,
}) => {
	return (
		<NavigationPopupStyled size={size} isSearchPopup={isSearchPopup} arrowOffset={arrowOffset}>
			<Flex flexDirection="column">
				<Flex justifyContent="space-between">
					<Text as="h3" variant="headline-3" mb={0}>
						{isSearchPopup ? heading?.toUpperCase() : heading}
					</Text>
					<ButtonStyled
						aria-label="Stäng modal"
						onClick={() => {
							sessionStorage.setItem("hideLoginPopup", "1")
							showPopup(false)
						}}
					>
						<Icon icon="close" />
					</ButtonStyled>
				</Flex>
				{children}
			</Flex>
		</NavigationPopupStyled>
	)
}

export { NavigationPopup }
